import React, { useEffect, useState } from "react";
import Addicon from "../../assets/svg/Addicon.svg";
import {
  Avatar,
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TextField,
  Pagination,
  InputAdornment,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import DeleteConfirmationPopup from "../common/DeleteConfirmationPopup";
import { orgAdminLinks } from "../../store/enterprise/action";
import { useDispatch } from "react-redux";
import AddUser from "./AddUser";

export default function UserManagement() {
  const [userList, setUserList] = useState([]);
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();

  const rowsPerPage = 5;

  useEffect(() => {
    getAdminListOrganizationWise();
  }, []);

  const getAdminListOrganizationWise = async () => {
    try {
      const resp = await dispatch(orgAdminLinks({}));
      const data = resp.payload;
      // Ensure we always set an array
      setUserList(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching admin users:", error);
      setUserList([]);
    }
  };

  const filteredList = (Array.isArray(userList) ? userList : []).filter(
    (row) => {
      const fullName = `${row?.UserFirstName ?? ""} ${
        row?.UserMiddleName ?? ""
      } ${row?.UserLastName ?? ""}`.toLowerCase();
      return (
        fullName.includes(searchText.toLowerCase()) ||
        row?.OrganizationStructureName?.toLowerCase()?.includes(
          searchText.toLowerCase(),
        ) ||
        row?.UserEmail?.toLowerCase()?.includes(searchText.toLowerCase())
      );
    },
  );

  const totalPages = Math.ceil(filteredList.length / rowsPerPage);
  const paginatedList = filteredList.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage,
  );

  const handlePageChange = (_, page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <AddUser
        open={open}
        setOpen={setOpen}
        getAdminListOrganizationWise={getAdminListOrganizationWise}
      />

      <Box
        sx={{
          margin: "25px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography variant="h6" fontWeight={500}>
            User Management
          </Typography>
          <Typography variant="body2" color="textSecondary">
            List of all the Enterprises Admin Users
          </Typography>
        </Box>

        <Box display="flex" gap={2}>
          <Button
            sx={{ height: "40px" }}
            variant="contained"
            size="small"
            endIcon={<img src={Addicon} alt="Addicon" />}
            onClick={() => setOpen(true)}
          >
            Add
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          padding: "20px",
          backgroundColor: "#fff",
          margin: "25px",
          borderRadius: "8px",
        }}
      >
        <TextField
          size="small"
          placeholder="Search name/org/email"
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            setCurrentPage(1);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Organization Name</TableCell>
                <TableCell>Admin Name</TableCell>
                <TableCell>User ID</TableCell>
                <TableCell>User Email</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedList.length > 0 ? (
                paginatedList.map((row) => (
                  <TableRow key={row.OrganizationStructureID}>
                    <TableCell>
                      <Avatar
                        alt={row?.UserFirstName || "User"}
                        src={
                          row?.UserPhoto ||
                          `https://i.pravatar.cc/150?u=${row.UserID}`
                        }
                      />
                    </TableCell>
                    <TableCell>{row?.OrganizationStructureName}</TableCell>
                    <TableCell>
                      {row?.UserFirstName} {row?.UserMiddleName}{" "}
                      {row?.UserLastName}
                    </TableCell>
                    <TableCell>{row?.UserName}</TableCell>
                    <TableCell>{row?.UserEmail}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No users found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 2,
          }}
        >
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
            color="primary"
            siblingCount={0}
            boundaryCount={1}
          />
        </Box>

        <DeleteConfirmationPopup
          open={false}
          onClose={() => {}}
          onConfirm={() => {}}
          title="Are you sure you want to delete this? This action cannot be undone."
        />
      </Box>
    </>
  );
}
